import React, { useCallback, useEffect, useState } from 'react';
import apiClient from '../../api/axiosInstance';
import { COST_ALERT_LABELS } from './notification.constants';
import UsagePercentBar from './UsagePercentBar';
import styles from './CostAlertPanel.module.scss';

const getStatusData = (response) => response?.data?.data;

const CostAlertPanel = () => {
  const [status, setStatus] = useState(null);
  const [loadError, setLoadError] = useState('');

  const loadCostAlertStatus = useCallback(async () => {
    setLoadError('');

    try {
      const response = await apiClient.get('/notification/org/cost-alert-status');
      setStatus(getStatusData(response));
    } catch (error) {
      setLoadError(error?.response?.data?.message || COST_ALERT_LABELS.loadError);
    }
  }, []);

  useEffect(() => {
    loadCostAlertStatus();
  }, [loadCostAlertStatus]);

  if (!status && !loadError) {
    return <p className={styles.status}>{COST_ALERT_LABELS.loading}</p>;
  }

  if (loadError) {
    return <p className={`${styles.status} ${styles.error}`} role="alert">{loadError}</p>;
  }

  if (status.unlimited) {
    return (
      <section className={styles.panel} aria-labelledby="cost-alert-heading">
        <h2 id="cost-alert-heading">{COST_ALERT_LABELS.heading}</h2>
        <p className={styles.unlimited}>{COST_ALERT_LABELS.unlimited}</p>
      </section>
    );
  }

  return (
    <section className={styles.panel} aria-labelledby="cost-alert-heading">
      <div className={styles.header}>
        <h2 id="cost-alert-heading">{COST_ALERT_LABELS.heading}</h2>
        <span className={styles.percent}>{status.percentUsed}% {COST_ALERT_LABELS.percentSuffix}</span>
      </div>
      <UsagePercentBar percent={status.percentUsed} />
      <p className={styles.usage}>
        {COST_ALERT_LABELS.usage}: {status.creditsUsed} / {status.creditLimit}
      </p>
    </section>
  );
};

export default CostAlertPanel;
